
import {Component, Vue} from "vue-property-decorator";
import VueMore from "./components/btn.vue";
import VueSection from "./components/section/index.vue";
import VueZz from "./components/zzzs.vue";
import VueList from "./components/list.vue"
import vanPopup from 'vant/lib/popup';

import vanSwipe from 'vant/lib/swipe';
import vanSwipeItem from 'vant/lib/swipe-item';
import 'vant/lib/swipe/style';
import 'vant/lib/swipe-item/style';


@Component({
    components:{
        VueSection,
        VueMore,
        VueZz,
        vanSwipe,
        vanSwipeItem,
        vanPopup,
        VueList
    }
})
export default class HomeClass extends Vue {


    public index:any = '';

    public show:boolean=false;
    public images:any = [
        'http://img.nirne.com/lunbo1.jpg',
        'http://img.nirne.com/lunbo2.jpg',
        'http://img.nirne.com/lunbo/1.jpg',
        'http://img.nirne.com/lunbo/26.jpg',
    ]
    public onActiveIndex:any = 0;

    public tabClick(index:number){
        this.onActiveIndex = index;
    }

    public tabClick1(index:any){

        // this.show = true;

        this.index = index;
        this.$router.push(`/mobileIndex/product?type=${index}`)
    }

    public handleSelect(key: any) {
        this.$router.push(`/mobileIndex/solution?type=${key}`)
    }
}
